import { render, staticRenderFns } from "./createHomePage.vue?vue&type=template&id=36bee4a2&"
import script from "./createHomePage.vue?vue&type=script&lang=js&"
export * from "./createHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports